import { connectHook } from 'app/common/components/connect-hook';
import { SimpleLink } from './simple-link.js';
import { useSimpleLink } from './simple-link-hook.js';

export default connectHook(SimpleLink, useSimpleLink);
